import * as producerJSON from "./producer.json"
import * as townJSON from "./town.json"
import * as stillJSON from "./still.json"
import * as fermenterJSON from "./fermenter.json"
import * as brandJSON from "./brand.json"
import * as municipalityJSON from "./municipality.json"
import * as stateJSON from "./state.json"
import * as brandToProducerJSON from "./brand-to-producer.json"

import * as commonJSON from "./common.json"
import * as speciesJSON from "./species.json"
import * as subspeciesJSON from "./subspecies.json"
import * as commonToSpeciesJSON from "./common-to-species.json"

export const producers = producerJSON.default
export const towns = townJSON.default
export const stills = stillJSON.default
export const fermenters = fermenterJSON.default
export const brands = brandJSON.default
export const municipalities = municipalityJSON.default
export const states = stateJSON.default
export const brandsToProducers = brandToProducerJSON.default

export const commonNames = commonJSON.default
export const speciesNames = speciesJSON.default
export const subspeciesNames = subspeciesJSON.default
export const commonToSpecies = commonToSpeciesJSON.default

export const spanishStillLabels = [
	{
		"id" : 1,
		"name" : "Ollas de Barro"
	},
	{
		"id" : 2,
		"name" : "Cobre e Inoxidable con Refrescador"
	},
	{
		"id" : 3,
		"name" : "Alambique de Cobre e Inoxidable"
	},
	{
		"id" : 4,
		"name" : "Alambique de Cobre y Madera"
	},
	{
		"id" : 5,
		"name" : "Alambique de Cobre"
	},
	{
		"id" : 6,
		"name" : "Alambique de Cobre con Refrescador"
	},
	{
		"id" : 7,
		"name" : "Olla de Barro y Madera"
	},
	{
		"id" : 8,
		"name" : "Alambique de Inoxidable"
	},
	{
		"id" : 9,
		"name" : "Olla de Barro y Acero Inoxidable"
	},
	{
		"id" : 10,
		"name" : "Alambique de Inoxidable con Refrescador"
	},
	{
		"id" : 11,
		"name" : "Olla de Barro y Cobre"
	}
]

export const spanishFermenterLabels = [
	{
		"id" : 1,
		"name" : "Canoa"
	},
	{
		"id" : 2,
		"name" : "Olla de Barro"
	},
	{
		"id" : 3,
		"name" : "Cemento"
	},
	{
		"id" : 4,
		"name" : "Cuero"
	},
	{
		"id" : 5,
		"name" : "Plástico"
	},
	{
		"id" : 6,
		"name" : "Inoxidable"
	},
	{
		"id" : 7,
		"name" : "Piedra"
	},
	{
		"id" : 8,
		"name" : "Various"
	},
	{
		"id" : 9,
		"name" : "Madera"
	},
	{
		"id" : 10,
		"name" : "Madera Enterrada"
	}
]
